import api from './api';

const adminService = {
  // Platform stats
  getPlatformStats: async () => {
    const response = await api.get('/api/admin/stats');
    return response.data;
  },

  // Landlord management
  getLandlords: async () => {
    const response = await api.get('/api/admin/landlords');
    return response.data;
  },

  getLandlordStats: async (landlordId) => {
    const response = await api.get(`/api/admin/landlords/${landlordId}/stats`);
    return response.data;
  },

  createLandlord: async (data) => {
    const response = await api.post('/api/admin/landlords', data);
    return response.data;
  },

  updateLandlord: async (landlordId, data) => {
    const response = await api.put(`/api/admin/landlords/${landlordId}`, data);
    return response.data;
  },

  deleteLandlord: async (landlordId) => {
    await api.delete(`/api/admin/landlords/${landlordId}`);
  },

  // Password reset
  resetLandlordPassword: async (landlordId, newPassword) => {
    const response = await api.post(`/api/admin/landlords/${landlordId}/reset-password`, { new_password: newPassword });
    return response.data;
  },

  // M-Pesa config
  getLandlordMpesaConfig: async (landlordId) => {
    const response = await api.get(`/api/admin/landlords/${landlordId}/mpesa-config`);
    return response.data;
  },
  saveLandlordMpesaConfig: async (landlordId, data) => {
    const response = await api.post(`/api/admin/landlords/${landlordId}/mpesa-config`, data);
    return response.data;
  },
  updateMpesaBalance: async (landlordId, balance) => {
    const response = await api.post(`/api/admin/landlords/${landlordId}/mpesa-balance?balance=${balance}`);
    return response.data;
  },

  // SMS config
  getLandlordSmsConfig: async (landlordId) => {
    const response = await api.get(`/api/admin/landlords/${landlordId}/sms-config`);
    return response.data;
  },
  saveLandlordSmsConfig: async (landlordId, data) => {
    const response = await api.post(`/api/admin/landlords/${landlordId}/sms-config`, data);
    return response.data;
  },

  // Commission
  getGlobalCommission: async () => {
    const response = await api.get('/api/admin/commission');
    return response.data;
  },
  saveGlobalCommission: async (data) => {
    const response = await api.post('/api/admin/commission', data);
    return response.data;
  },
  getLandlordCommission: async (landlordId) => {
    const response = await api.get(`/api/admin/landlords/${landlordId}/commission`);
    return response.data;
  },
  saveLandlordCommission: async (landlordId, data) => {
    const response = await api.post(`/api/admin/landlords/${landlordId}/commission`, data);
    return response.data;
  },

  // Wallet
  getWallet: async () => {
    const response = await api.get('/api/admin/wallet');
    return response.data;
  },
  getWalletTransactions: async (skip = 0, limit = 50) => {
    const response = await api.get(`/api/admin/wallet/transactions?skip=${skip}&limit=${limit}`);
    return response.data;
  },
  getWithdrawals: async () => {
    const response = await api.get('/api/admin/wallet/withdrawals');
    return response.data;
  },
  requestWithdrawal: async (data) => {
    const response = await api.post('/api/admin/wallet/withdraw', data);
    return response.data;
  },
  updateWithdrawalStatus: async (withdrawalId, newStatus) => {
    const response = await api.put(`/api/admin/wallet/withdrawals/${withdrawalId}/status?new_status=${newStatus}`);
    return response.data;
  },
};

export default adminService;
